import Vue from "vue";
import Element from "element-ui";
import "./main.scss";

Vue.use(Element);
